import { Helmet } from 'react-helmet-async';
import { filter, method } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { format, parseISO } from 'date-fns';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { jwtDecode } from 'jwt-decode';

// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  DialogContentText,
  Grid,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Tooltip,
  TableHead,
  Box,
  LinearProgress,
} from '@mui/material';
import { toast } from 'react-toastify';

// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { validateForm } from '../utils/validationUtils';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// mock
import useUsers from '../hooks/useUsers';
import DeactivateModal from './components/deactivateMember/deactivateModal/DeactivateModal';
import DeactivatedMembers from './components/deactivateMember/deactivatedMembers/DeactivatedMembers';
import ReactivateModal from './components/reactivateMember/reactivateModal/ReactivateModal'
// import MultiMark from './components/attendanceMember/MultiMark';

import { API_BASE_URL } from '../utils/env';


const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'gener', label: 'Gender', alignRight: false },
  { id: 'memberType', label: 'Type', alignRight: false },
  { id: 'birthday', label: 'Birthday', alignRight: false },
  { id: 'department', label: 'Department', alignRight: false },
  { id: 'attendance', label: 'Attendance', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (!a || !b || !a[orderBy] || !b[orderBy]) return 0; // Prevent errors

  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}


function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Search functionality
function applySortFilter(array, comparator, query) {
  const validArray = array.filter((user) => user && user.firstName && user.lastName); // Remove nulls
  const stabilizedThis = validArray.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    const lowerQuery = query.toLowerCase();
    return validArray.filter((_user) =>
      _user.firstName.toLowerCase().includes(lowerQuery) ||
      _user.lastName.toLowerCase().includes(lowerQuery)
    );
  }

  return stabilizedThis.map((el) => el[0]);
}


export default function UserPage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [multiMakredLoading, setMultiMakredLoading] = useState(false)

  const [activateMemberLoading, setActivateMemberLoading] = useState(false);

  const [open, setOpen] = useState(null);


  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openDialog, setOpenDialog] = useState(false);

  const [openDeactivateDialog, setOpenDeactivateDialog] = useState(false);

  const [openReactivateDialog, setOpenReactivateDialog] = useState(false);

  const [deactivatedMembersOpenClick, setDeactivatedMembersOpenClick] = useState(false);

  const [selectedUserId, setSelectedUserId] = useState(null);

  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const [markedUsers, setMarkedUsers] = useState(false);

  const [multiMakked, setMultiMarked] = useState(false);

  const [singleMarked, setSingleMarked] = useState(false);

  const { userInfo } = useSelector((state) => state.auth);

  // Decode JWT token to get user information
  const decodedToken = jwtDecode(userInfo.token);

  // Extract the 'id' from the decoded token
  const parishId = decodedToken.parishId;

  // console.log(parishId);

  // token to be used in headers
  const token = userInfo.token;

  // i am setting this extra state to control the image
  const [imageUrl, setImageUrl] = useState('');

  const [formData, setFormData] = useState({
    // New state for form data
    ParishId: `${parishId}`,
    FirstName: '',
    LastName: '',
    Gender: '',
    PhoneNumber: '',
    DateOfBirth: null,
    Country: '',
    State: '',
    Address: '',
    Email: '',
    YearJoined: null,
    NextOfKin: '',
    NextOfKinPhone: '',
    MemberType: '',
    Department: '',
    MarriageAnniversary: null,
    biometricId: null
  });

  // use the useUsers hook
  const {
    deactivatedMembers,
    deactivatedMembersError,
    deactivatedMembersLoader,
    setDeactivatedMembers,
    setDeactivatedMembersError,
  } = useUsers();

  const [USERLIST, setUsers] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(null);

  // use effect to fetch members
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/Member/GetMemberByParishId?ParishId=${parishId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          // Attempt to capture the error message from the response
          const errorResponse = await response.json();
          const errorMessage = errorResponse.error;
          throw new Error(errorMessage);
        }
        const responseData = await response.json();

        if (responseData.success && responseData.data === null) {
          // Handle the case where the API returns null for data
          setUsers([]);
          setLoader(false);
          setError(responseData.message);
        } else {
          // Handle the case where data is not null
          setUsers(responseData.data);
          setLoader(false);
          setError(null);
          // console.log(responseData.data);
        }
      } catch (error) {
        setLoader(false);
        setError(error.message);
        console.log(error);
      }
    };

    fetchUsers();
  }, [parishId, rowsPerPage, page]);

  const handleFormChange = (event) => {
    if (event.target) {
      const { name, value } = event.target;
      setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    }
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = USERLIST.map((user) => user.memberId);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };


  const handleClick = (event, memberId) => {
    const selectedIndex = selected.indexOf(memberId);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, memberId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  // --------------------------------
  const [showDepartment, setShowDepartment] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [memberType, setMemberType] = useState([]);
  const [departmentPreference, setDepartmentPreference] = useState([]);

  const [markedAttendanceIds, setMarkedAttendanceIds] = useState(() => {
    // Initialize state from local storage
    const storedIds = localStorage.getItem('markedAttendanceIds');
    return storedIds ? JSON.parse(storedIds) : [];
  });

  const [markedMemberLoading, setMarkedMemberLoading] = useState(false);
  const [loadingButtonId, setLoadingButtonId] = useState(null);
  const [multiMarkedLoading, setMultiMarkedLoading] = useState(false);

  // Sync state with local storage whenever markedAttendanceIds changes
  useEffect(() => {
    localStorage.setItem('markedAttendanceIds', JSON.stringify(markedAttendanceIds));
  }, [markedAttendanceIds]);

  const genderOptions = [
    { value: '1', label: 'Male' },
    { value: '2', label: 'Female' },
  ];

  // get all countries on load of page
  useEffect(() => {
    fetch(`${API_BASE_URL}/DropDown/GetAllCountries`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCountries(data);
      })
      .catch((error) => {
        toast.error('Error fetching countries:', error);
      });
  }, [parishId, token]);

  // use effect to grab state data below
  useEffect(() => {
    fetch(`${API_BASE_URL}/DropDown/GetAllStates`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setStates(data);
      })
      .catch((error) => {
        toast.error('Error fetching states:', error);
      });
  }, [parishId, token]);

  // use effect to grab member type data
  useEffect(() => {
    fetch(`${API_BASE_URL}/Member/GetMemberTypeByParish?Id=${parishId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setMemberType(data.data);
      })
      .catch((error) => {
        toast.error('Error fetching Member type:', error);
      });
  }, [parishId, token]);

  // use effect to grab preference department data
  useEffect(() => {
    fetch(`${API_BASE_URL}/Parish/GetDepartmentByParish?Id=${parishId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setDepartmentPreference(data.data);
      })
      .catch((error) => {
        toast.error('Error fetching Department preference:', error);
      });
  }, [parishId, token]);

  const handleStatusChange = (event) => {
    const selectedStatusValue = event.target.value;
    setShowDepartment(
      selectedStatusValue === 'Worker' || selectedStatusValue === 'Deacon' || selectedStatusValue === 'Minister'
    );

    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleCountryChange = (event) => {
    const selectedCountryValue = event.target.value;
    setSelectedCountry(selectedCountryValue === 'Nigeria');

    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  useEffect(() => {
    console.log('Is Nigeria selected?', selectedCountry);
  }, [selectedCountry]);

  const handleAddMemberClick = () => {
    setOpenDialog(true); // Open the dialog when the button is clicked
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Close the dialog when user cancels
  };

  // dialogue state control for deactivate members
  const deactivateMemberOpenDialog = () => {
    setOpenDeactivateDialog(true);
  };

  const deactivateMemberCloseDialog = () => {
    setOpenDeactivateDialog(false);
  };

  // dialogue state control for reactivate members
  const reactivateMemberOpenDialog = (memberId) => {
    setOpenReactivateDialog(true);
    setSelectedMemberId(memberId);
  };

  const handleActivateMember = async () => {
    if (selectedMemberId) {
      const url = `${API_BASE_URL}/Member/ActivateMember?id=${selectedMemberId}&isActivate=true`;
      const token = userInfo.token;

      try {
        setActivateMemberLoading(true);

        const response = await fetch(url, {
          method: 'PATCH',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Handle successful response here if needed
        toast.success('Member reactivated successfully');

        // close the modal
        reactivateMemberCloseDialog();
        if (deactivatedMembers.length < 0) {
          handleDeactivatedMembersCloseClick();
        }

        // Find the activated member in deactivatedMembers
        const activatedMember = deactivatedMembers.find((member) => member.memberId === selectedMemberId);

        // update the table
        setUsers((prevDeactivatedMembers) => [...prevDeactivatedMembers, activatedMember]);

        // Remove the activated member from deactivatedMembers
        setDeactivatedMembers((prevDeactivatedMembers) =>
          prevDeactivatedMembers.filter((member) => member.memberId !== selectedMemberId)
        );

        // Clear the selected memberId after successful activation
        setSelectedMemberId(null);
      } catch (error) {
        console.error('Error activating member:', error.message);
        toast.error(`Error activating member ${error.message}`);
      } finally {
        setActivateMemberLoading(false);
      }
    }
  };

  const reactivateMemberCloseDialog = () => {
    setOpenReactivateDialog(false);
  };

  const handleViewUser = async () => {
    if (!selectedUserId) {
      toast('no selected user ');
      return; // No user selected, return early
    }
    navigate(`/dashboard/members/${selectedUserId}/memberview`);
    console.log(selectedUserId);
  };

  const handleDateFormChange = (date, fieldName) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: date || null, // Keep as Date object or set to null if cleared
    }));
  };

  const handleCreateMember = () => {
    // const today = new Date();

    // if (formData.YearJoined && parseISO(formData.YearJoined) > today) {
    //   toast.error("Year joined cannot be in the future.");
    //   return;
    // }

    const today = new Date();
    const yearJoined = new Date(`${formData.YearJoined}-01-01`); // Ensure a full date

    if (formData.YearJoined && yearJoined > today) {
      toast.error("Year joined cannot be in the future.");
      return;
    }

    const endpoint = `${API_BASE_URL}/Member/AddMember`;
    const memberData = new FormData();

    // Prepare form data before sending
    Object.keys(formData).forEach((key) => {
      let value = formData[key];

      if (value instanceof Date) {
        if (key === 'DateOfBirth' || key === 'MarriageAnniversary') {
          value = format(value, 'MM-dd');
        } else {
          value = format(value, 'yyyy-MM-dd');
        }
      } else if (key === 'YearJoined' && value) {
        value = `01-01-${value}`;
      } else if (key === 'MarriageAnniversary' && (!value || value === '')) {
        value = '';
      }

      memberData.append(key, value);
    });

    memberData.append('MemberImage', imageUrl);

    const errors = validateForm(formData);

    if (Object.keys(errors).length === 0) {
      setLoading(true);
      axios
        .post(endpoint, memberData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          setLoading(false);

          if (response.data.success) {
            setOpenDialog(false);
            setUsers((prevData) => [...prevData, response.data.data]);
            toast.success('Member created successfully');
          } else {
            toast.error(response.data.message || 'Failed to create member');
          }
        })
        .catch((error) => {
          setLoading(false);
          const errorMessage = error.response?.data?.message || 'An error occurred';
          toast.error(errorMessage);
          // console.error('Error adding user:', error.response?.data);
        });
    } else {
      Object.values(errors).forEach((error) => toast.error(error));
    }
  };



  const handleDeactivatedMembersOpenClick = () => {
    setDeactivatedMembersOpenClick(true);
  };

  const handleDeactivatedMembersCloseClick = () => {
    setDeactivatedMembersOpenClick(false);
  };

  // icons on table head
  const isDeactivatedMembersIconVisible = true;
  const showHeadCheckBox = true;

  function formatDateOfBirth(inputDate) {
    // Parse the input date
    const date = new Date(inputDate);

    // Check if the date is valid
    if (Number.isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    // Get the abbreviated month name
    const monthName = date.toLocaleString('default', { month: 'short' });

    // Format the month name with a period
    const formattedMonth = `${monthName}.`;

    // Get the day component
    const formattedDay = date.getDate();

    // Concatenate the formatted components into the desired format
    const formattedDate = `${formattedMonth} ${formattedDay}`;

    return formattedDate;
  }

  // beinging of the functionality for attendance ---------------
  useEffect(() => {
    const fetchAttendance = async () => {
      const currentDate = new Date();
      const presentDate = currentDate.toISOString().split('T')[0];

      const requestBody = {
        parishId,
        startDate: presentDate,
        endDate: presentDate,
        page: page + 1,
        pageSize: rowsPerPage,
      };


      try {
        const response = await fetch(`${API_BASE_URL}/Attendance/GetAttendance`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (response.ok) {
          const data = await response.json();
          setMarkedAttendanceIds(data.data.map((member) => member.memberId));
        } else {
          console.error('Failed to fetch attendance data');
        }
      } catch (error) {
        console.error('Error fetching attendance data:', error);
      }
    };

    fetchAttendance();
  }, [parishId, token]);


  // Handle single attendance marking
  const handleSingleAttendance = async (memberId) => {
    setLoadingButtonId(memberId);
    try {
      setMarkedMemberLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/Attendance/DefaultAttendance?parishId=${parishId}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify([memberId]),
        }
      );

      if (response.ok) {
        toast.success('Attendance marked successfully');
        setMarkedAttendanceIds((prevIds) => [...prevIds, memberId]);
      } else {
        const errorData = await response.json();
        console.error('Failed to mark attendance:', errorData);
        toast.error('Failed to mark attendance.');
      }
    } catch (error) {
      console.error('Error marking attendance:', error);
      toast.error('An error occurred while marking attendance.');
    } finally {
      setMarkedMemberLoading(false);
      setLoadingButtonId(null);
    }
  };

  // Handle multiple attendance marking
  const handleMarkAllAttendance = async () => {
    if (selected.length === 0) {
      toast.warning('No members selected for attendance.');
      return;
    }

    const currentDate = new Date().toISOString().split('T')[0];

    const requestBody = {
      parishId,
      startDate: currentDate,
      endDate: currentDate,
    };

    try {
      // Fetch existing attendance data
      const attendanceResponse = await fetch(`${API_BASE_URL}/Attendance/GetAttendance`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!attendanceResponse.ok) {
        toast.error('Failed to retrieve attendance data.');
        return;
      }

      const attendanceData = await attendanceResponse.json();
      const markedAttendance = attendanceData.data || [];

      // Check for already marked members
      const alreadyMarked = selected.some((memberId) =>
        markedAttendance.some((marked) => marked.memberId === memberId)
      );

      if (alreadyMarked) {
        toast.warning('Some selected members are already marked.');
        return;
      }

      setMultiMarkedLoading(true);

      // Mark attendance for selected members
      const markAttendanceResponse = await fetch(
        `${API_BASE_URL}/Attendance/DefaultAttendance?parishId=${parishId}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(selected),
        }
      );

      if (markAttendanceResponse.ok) {
        toast.success('Attendance marked successfully for selected members.');
        setMarkedAttendanceIds((prevIds) => [...prevIds, ...selected]);
        setSelected([]);
      } else {
        const errorData = await markAttendanceResponse.json();
        console.error('Failed to mark attendance:', errorData);
        toast.error('Failed to mark attendance for selected members.');
      }
    } catch (error) {
      console.error('Error marking attendance:', error);
      toast.error('An error occurred while marking attendance.');
    } finally {
      setMultiMarkedLoading(false);
    }
  };

  // Handle unmarking attendance
  const handleUnmarkAttendance = async (memberId) => {
    const currentDate = new Date();
    const formattedDate = `${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate
        .getDate()
        .toString()
        .padStart(2, '0')}-${currentDate.getFullYear()}`;

    const presentDate = currentDate.toISOString().split('T')[0];

    const requestBody = {
      parishId,
      startDate: presentDate,
      endDate: presentDate,
      page,
      pageSize: page,
    };

    const unmarkEndpoint = `${API_BASE_URL}/Attendance/DeleteAttendance?date=${formattedDate}`;

    try {
      setMarkedMemberLoading(true);
      setLoadingButtonId(memberId);

      // Send DELETE request to unmark attendance
      const response = await fetch(unmarkEndpoint, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([memberId]),
      });

      if (response.ok) {
        toast.success('Attendance unmarked successfully');

        // Fetch updated attendance list
        const attendanceResponse = await fetch(
          `${API_BASE_URL}/Attendance/GetAttendance`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
          }
        );

        if (attendanceResponse.ok) {
          const attendanceData = await attendanceResponse.json();

          // Update `markedAttendanceIds` with the new state
          setMarkedAttendanceIds(
            attendanceData.data.map((member) => member.memberId)
          );
        } else {
          toast.error('Failed to refresh attendance list.');
        }
      } else {
        const errorData = await response.json();
        console.error('Failed to unmark attendance:', errorData);
        toast.error('Failed to unmark attendance.');
      }
    } catch (error) {
      console.error('Error unmarking attendance:', error);
      toast.error('An error occurred while unmarking attendance.');
    } finally {
      setMarkedMemberLoading(false);
      setLoadingButtonId(null);
    }
  };

  // Handle multiple attendance unmarking
  const handleUnmarkAllAttendance = async () => {
    if (selected.length === 0) {
      toast.warning('No members selected for unmarking.');
      return;
    }

    const currentDate = new Date();
    const formattedDate = `${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate
        .getDate()
        .toString()
        .padStart(2, '0')}-${currentDate.getFullYear()}`;

    const presentDate = currentDate.toISOString().split('T')[0];

    const requestBody = {
      parishId,
      startDate: presentDate,
      endDate: presentDate,
    };

    try {
      // Fetch existing attendance data
      const attendanceResponse = await fetch(`${API_BASE_URL}/Attendance/GetAttendance`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!attendanceResponse.ok) {
        toast.error('Failed to retrieve attendance data.');
        return;
      }

      const attendanceData = await attendanceResponse.json();
      const markedAttendance = attendanceData.data || [];
      console.log(markedAttendance);


      // console.log("Fetched Attendance Data:", markedAttendance);

      // Identify members who are NOT marked
      const notMarkedMembers = selected.filter(
        (memberId) => !markedAttendance.some((marked) => marked.memberId === memberId)
      );

      if (notMarkedMembers.length > 0) {
        console.log("These members are not marked:", notMarkedMembers);
        toast.warning('Some selected members are not marked.');
        return;
      }

      setMultiMarkedLoading(true);

      // Unmark attendance for selected members
      const unmarkAttendanceResponse = await fetch(
        `${API_BASE_URL}/Attendance/DeleteAttendance?date=${formattedDate}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(selected),
        }
      );

      if (unmarkAttendanceResponse.ok) {
        toast.success('Attendance unmarked successfully for selected members.');

        // Remove the unmarked IDs from `markedAttendanceIds`
        setMarkedAttendanceIds((prevIds) =>
          prevIds.filter((id) => !selected.includes(id))
        );

        // Clear selected members
        setSelected([]);
      } else {
        const errorData = await unmarkAttendanceResponse.json();
        console.error('Failed to unmark attendance:', errorData);
        toast.error('Failed to unmark attendance for selected members.');
      }
    } catch (error) {
      console.error('Error unmarking attendance:', error);
      toast.error('An error occurred while unmarking attendance.');
    } finally {
      setMultiMarkedLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> All Members | CaaS </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            All Members
          </Typography>
          <Button
            sx={{ backgroundColor: '#000080' }}
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={handleAddMemberClick}
          >
            Add Member
          </Button>
        </Stack>
        {loader ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress sx={{ color: '#000080' }} />
          </Box>
        ) : (
          <Card style={{ background: '#fcfcfc' }}>
            <UserListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              deactivatedMembersClick={handleDeactivatedMembersOpenClick}
              markAllAttendance={handleMarkAllAttendance}
              unMarkAllAttendance={handleUnmarkAllAttendance}
              showDeactivatedMembersIcon={isDeactivatedMembersIconVisible}
            // onFilterClick={handleFilterFunction}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }} style={{ background: '#fcfcfc' }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={USERLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    showHeadCheckBox={showHeadCheckBox}
                  />
                  <TableBody>
                    {filteredUsers
                      .slice()
                      .reverse()
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => {
                        const {
                          memberId,
                          firstName,
                          lastName,
                          memberType,
                          gender,
                          birthday,
                          department,
                          phoneNumber,
                          isMarked,
                        } = row;
                        const selectedUser = selected.indexOf(memberId) !== -1;

                        return (
                          <TableRow hover key={memberId} tabIndex={-1} role="checkbox" selected={selectedUser}>
                            <TableCell padding="checkbox">
                              <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, memberId)} />
                            </TableCell>

                            <TableCell component="th" scope="row" padding="none">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar alt={lastName} src="./fakePath.png" />

                                <div className="wrap">
                                  <div className="name">
                                    <Typography variant="subtitle2" noWrap>
                                      {`${lastName} ${firstName}`}
                                    </Typography>
                                  </div>

                                  <div className="phone">
                                    <Typography variant="subtitle6" noWrap>
                                      {`${phoneNumber}`}
                                    </Typography>
                                  </div>
                                </div>
                              </Stack>
                            </TableCell>

                            <TableCell align="left">{`${gender}`}</TableCell>

                            <TableCell align="left">{`${memberType}`}</TableCell>

                            <TableCell align="left">{`${formatDateOfBirth(birthday)}`}</TableCell>

                            <TableCell align="left">{`${department}`}</TableCell>
                            <TableCell>
                              {isMarked || markedAttendanceIds.includes(memberId) ? (
                                <Button
                                  variant="contained"
                                  size="small"
                                  sx={{ backgroundColor: '#4B4B8E' }}
                                  onClick={() => {
                                    const confirmUnmark = window.confirm(
                                      `Are you sure you want to unmark the attendance of ${lastName} ${firstName}?`
                                    );
                                    if (confirmUnmark) {
                                      handleUnmarkAttendance(memberId);
                                    }
                                  }}
                                  disabled={loadingButtonId === memberId}
                                >
                                  {loadingButtonId === memberId ? (
                                    <CircularProgress size="1.5rem" sx={{ color: 'rgba(145, 158, 171, 0.24)' }} />
                                  ) : (
                                    'Unmark'
                                  )}
                                </Button>
                              ) : (
                                <Button
                                  variant="contained"
                                  size="small"
                                  sx={{ backgroundColor: '#000080' }}
                                  onClick={() => handleSingleAttendance(memberId)}
                                  disabled={loadingButtonId === memberId}
                                >
                                  {loadingButtonId === memberId ? (
                                    <CircularProgress size="1.5rem" sx={{ color: 'rgba(145, 158, 171, 0.24)' }} />
                                  ) : (
                                    'Mark'
                                  )}
                                </Button>
                              )}
                            </TableCell>

                            <TableCell align="right">
                              <IconButton
                                size="large"
                                color="inherit"
                                onClick={(event) => {
                                  setSelectedUserId(memberId);
                                  handleOpenMenu(event);
                                }}
                              >
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>

                            <Popover
                              open={Boolean(open)}
                              anchorEl={open}
                              onClose={handleCloseMenu}
                              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                              PaperProps={{
                                sx: {
                                  p: 1,
                                  width: 140,
                                  '& .MuiMenuItem-root': {
                                    px: 1,
                                    typography: 'body2',
                                    borderRadius: 0.75,
                                  },
                                },
                              }}
                            >
                              <Link
                                to={`/dashboard/members/${selectedUserId}/memberview`}
                                style={{ textDecoration: 'none', color: '#212B36' }}
                              >
                                <MenuItem>
                                  <Iconify icon={'carbon:view-filled'} sx={{ mr: 2 }} onClick={handleViewUser} />
                                  View
                                </MenuItem>
                              </Link>

                              <MenuItem
                                onClick={(event) => {
                                  deactivateMemberOpenDialog(event);
                                  handleCloseMenu(event);
                                }}
                                sx={{ color: 'error.main' }}
                              >
                                <Iconify icon={'flowbite:user-remove-solid'} sx={{ mr: 2 }} />
                                Deactivate
                              </MenuItem>
                            </Popover>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {error ? (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph color={'#585858'}>
                              Message:
                            </Typography>

                            <Typography variant="body2" color={'#808191'}>
                              {error}
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    isNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <Paper
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography variant="h6" paragraph>
                                Not found
                              </Typography>

                              <Typography variant="body2">
                                No results found for &nbsp;
                                <strong>&quot;{filterName}&quot;</strong>.
                                <br /> Try checking for typos or using complete words.
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={USERLIST.length}
              // count={12}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}

        {/* Dialog for creating a new member */}
        <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Add New Member</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 1 }}>Please enter the details for the new member:</DialogContentText>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  value={formData.LastName}
                  name="LastName"
                  onChange={handleFormChange}
                  label="Last Name"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  value={formData.FirstName}
                  name="FirstName"
                  onChange={handleFormChange}
                  label="First Name"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Phone Number"
                  value={formData.PhoneNumber}
                  name="PhoneNumber"
                  onChange={handleFormChange}
                  type="number"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  value={formData.Email}
                  name="Email"
                  type="email"
                  onChange={handleFormChange}
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      views={['month', 'day']}
                      label="Date of Birth"
                      value={formData.DateOfBirth}
                      name="DateOfBirth"
                      onChange={(date) => handleDateFormChange(date, 'DateOfBirth')}
                      renderInput={(params) => <TextField {...params} />}
                      inputFormat="dd/MM"
                      sx={{
                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#000080',
                        },
                        '& .MuiInputLabel-outlined.Mui-focused': {
                          color: '#000080',
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>

              </Grid>


              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    value={formData.Gender}
                    onChange={handleFormChange}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Gender"
                    name="Gender"
                    sx={{
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#000080',
                        },
                        '& .MuiInputLabel-outlined': {
                          color: '#000080',
                        },
                      },
                    }}
                  >
                    {genderOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Member Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Member Type"
                    value={formData.MemberType}
                    name="MemberType"
                    onChange={handleStatusChange}
                    sx={{
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#000080',
                        },
                        '& .MuiInputLabel-outlined': {
                          color: '#000080',
                        },
                      },
                    }}
                  >
                    {memberType.map((option) => (
                      <MenuItem key={option.id} value={option.name}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Department</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formData.Department}
                    label="Department"
                    name="Department"
                    // disabled={!showDepartment} 
                    onChange={handleFormChange}
                    sx={{
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#000080',
                        },
                        '& .MuiInputLabel-outlined': {
                          color: '#000080',
                        },
                      },
                    }}
                  >
                    {departmentPreference.map((option) => (
                      <MenuItem key={option.id} value={option.departmentName}>
                        {option.departmentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Marriage Anniversary"
                    views={['month', 'day']}
                    value={formData.MarriageAnniversary}
                    name="MarriageAnniversary"
                    onChange={(date) => handleDateFormChange(date, 'MarriageAnniversary')}
                    renderInput={(params) => <TextField {...params} />}
                    maxDate={new Date()}
                    sx={{
                      // change the focus color
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#000080',
                      },
                      // the label color
                      '& .MuiInputLabel-outlined.Mui-focused': {
                        color: '#000080',
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={!selectedCountry ? 12 : 6}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Country of Origin</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Country of Origin"
                    onChange={handleCountryChange}
                    value={formData.Country}
                    name="Country"
                    sx={{
                      '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#000080',
                        },
                        '& .MuiInputLabel-outlined': {
                          color: '#000080',
                        },
                      },
                    }}
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.id} value={country.name}>
                        {country.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {selectedCountry && (
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">State of Origin</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="State of Origin"
                      disabled={!selectedCountry} // Disable the field when showDepartment is false
                      value={formData.State}
                      onChange={handleFormChange}
                      name="State"
                      sx={{
                        '&.Mui-focused': {
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#000080',
                          },
                          '& .MuiInputLabel-outlined': {
                            color: '#000080',
                          },
                        },
                      }}
                    >
                      {states.map((states) => (
                        <MenuItem key={states.id} value={states.name}>
                          {states.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <TextField
                  value={formData.Address}
                  name="Address"
                  onChange={handleFormChange}
                  label="Address"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    views={['year']}
                    label="Year Joined"
                    value={formData.YearJoined}
                    name="YearJoined"
                    onChange={(date) => handleDateFormChange(date, 'YearJoined')}
                    renderInput={(params) => <TextField {...params} />}
                    maxDate={new Date()}
                    format="yyyy"
                    sx={{
                      // change the focus color
                      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#000080',
                      },
                      // the label color
                      '& .MuiInputLabel-outlined.Mui-focused': {
                        color: '#000080',
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  value={formData.biometricId}
                  name="biometricId"
                  onChange={handleFormChange}
                  label="Biometrics ID"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  value={formData.NextOfKin}
                  name="NextOfKin"
                  onChange={handleFormChange}
                  label="Name of next of kin"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="number"
                  value={formData.NextOfKinPhone}
                  name="NextOfKinPhone"
                  onChange={handleFormChange}
                  label="Number of next of kin"
                  fullWidth
                  sx={{
                    // change the focus color
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#000080',
                    },
                    // the label color
                    '& .MuiInputLabel-outlined.Mui-focused': {
                      color: '#000080',
                    },
                  }}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6}>
                <input
                  name="MemberImage"
                  onChange={(e) => setImageUrl(e.target.files[0])}
                  type="file"
                  accept="image/png, image/jpeg"
                />
              </Grid> */}
            </Grid>
          </DialogContent>
          {/* ACTION BUTTONS ! */}
          <DialogActions>
            <Button
              onClick={handleCloseDialog}
              sx={{
                color: 'red',
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCreateMember}
              sx={{
                color: '#000080',
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Create'}
            </Button>
          </DialogActions>
        </Dialog>


        {/* Dialog prompt for deactivate member */}
        <DeactivateModal
          openDeactivateDialog={openDeactivateDialog}
          deactivateMemberCloseDialog={deactivateMemberCloseDialog}
          reactivateMemberOpenDialog={reactivateMemberOpenDialog}
          selectedUserId={selectedUserId}
          setSelectedUserId={setSelectedUserId}
          setUsers={setUsers}
          setDeactivatedMembers={setDeactivatedMembers}
          USERLIST={USERLIST}
          setDeactivatedMembersError={setDeactivatedMembersError}
        />

        {/* Dialog prompt for reactivate member */}
        <ReactivateModal
          reactivateMemberCloseDialog={reactivateMemberCloseDialog}
          openReactivateDialog={openReactivateDialog}
          handleActivateMember={handleActivateMember}
          activateMemberLoading={activateMemberLoading}
        />

        {/* Dialog prompt for deactivated member data display */}
        <DeactivatedMembers
          deactivatedMembersOpenClick={deactivatedMembersOpenClick}
          handleDeactivatedMembersCloseClick={handleDeactivatedMembersCloseClick}
          deactivatedMembers={deactivatedMembers}
          deactivatedMembersLoader={deactivatedMembersLoader}
          deactivatedMembersError={deactivatedMembersError}
          reactivateMemberOpenDialog={reactivateMemberOpenDialog}
        />
      </Container>
    </>
  );
}
